import React, { useContext, useEffect, useState } from "react";
import FinancialTotals from "./FinancialTotals";
import { Grid } from "@mui/material";
import TopSellingProd from "./TopSellingProd";
import TopCustomer from "./TopCustomer";
import SalesAvg from "./SalesAvg";
import OutletProg from "./OutletProg";
import HomeRepFilter from "./HomeRepFilter";
import moment from "moment";
import { AppContext } from "App";

const Home = () => {
  const { access } = useContext(AppContext);
  const [dAccess, setDAccess] = useState({});

  const [sortDate, setSortDate] = useState({
    fromDate: new Date(moment().startOf("month").toDate()),
    toDate: new Date(moment().endOf("month").toDate()),
  });

  useEffect(() => {
    access && setDAccess({ ...access?.dashboard });
    return () => {};
  }, [access]);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <HomeRepFilter {...{ sortDate, setSortDate }} />
        </Grid>

        {dAccess?.accountsWidgets && (
          <Grid item xs={12}>
            <FinancialTotals {...{ sortDate }} />
          </Grid>
        )}

        {dAccess?.inventoryValue && (
          <Grid item xs={12} md={4}>
            <SalesAvg {...{ sortDate }} />
          </Grid>
        )}

        {dAccess?.topSellingProduct && (
          <Grid item xs={12} md={4}>
            <TopSellingProd {...{ sortDate }} />
          </Grid>
        )}

        {dAccess?.topCustomer && (
          <Grid item xs={12} md={4}>
            <TopCustomer {...{ sortDate }} />
          </Grid>
        )}

        {dAccess?.allOutlets && (
          <Grid item xs={12}>
            <OutletProg {...{ sortDate }} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Home;
